import { lazy, Suspense } from "react";
import { Outlet, Route, Routes } from "react-router-dom";
import { PublicLayout } from "./components/layout/PublicLayout";
import { Home } from "./pages/Home";
import { Products } from "./pages/Products";
import { ProductDetails } from "./pages/ProductDetails";
import { Categories } from "./pages/Categories";
import { CategoryProducts } from "./pages/CategoryProducts";
import { About } from "./pages/About";
import { Contact } from "./pages/Contact";
import { NotFound } from "./pages/NotFound";
import { Helmet } from "react-helmet-async";
import { LoadingState } from "./components/ui/LoadingSpinner";

const AdminRoutes = lazy(() => import("./components/layout/AdminRoutes"));

function AdminIndexingBoundary() {
  return (
    <>
      <Helmet><meta name="robots" content="noindex, nofollow" /></Helmet>
      <Suspense fallback={<LoadingState label="Checking administrator access..." />}><Outlet /></Suspense>
    </>
  );
}

export function App() {
  return (
    <Routes>
      <Route element={<PublicLayout />}>
        <Route index element={<Home />} />
        <Route path="products" element={<Products />} />
        <Route path="products/page/:pageNumber" element={<Products />} />
        <Route path="products/:slug" element={<ProductDetails />} />
        <Route path="categories" element={<Categories />} />
        <Route path="categories/:slug" element={<CategoryProducts />} />
        <Route path="about" element={<About />} />
        <Route path="contact" element={<Contact />} />
      </Route>
      <Route element={<AdminIndexingBoundary />}>
        <Route path="admin/*" element={<AdminRoutes />} />
      </Route>
      <Route path="404" element={<NotFound />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
